import { useEffect } from 'react';

import { selectors as userSelectors } from 'core/use-cases/user';

export const useEventResellerId = () => {
  const {
    data: { resellerId, cycle },
  } = userSelectors.useUserSelector();

  useEffect(() => {
    if (!resellerId) {
      return;
    }

    dataLayer.push({
      userid: resellerId,
      cd_ciclo: cycle?.currentCycle,
    });
  }, [resellerId]);
};
